var exports = {
  "a": "Box__EJyBSi",
  "w": "Box_1__U2MxWd",
};

module.exports = exports;
